import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import ouiStyle from '@goldwasserexchange/oui-style';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import { TeamMembers } from './component';

export const TeamImage = () => (
  <ouiDom.HeadingSection.HeadingSection
    name="TeamImage"
    index={0}
    container={ouiStyle.Constants.Container.xl}
    padding="simple"
  >
    <TopModel<{
      textAlign?: ouiStyle.InStyleWithMediaQueries['textAlign'],
      paddingBottom: ouiStyle.InStyleWithMediaQueries['paddingBottom'],
    }>
      name="HeadingSectionTitleContainer-TeamImage"
      textAlign="center"
      paddingBottom="double"
    >
      {ouiDom.HeadingSection.DomH2}
    </TopModel>
    <TopModel
      name="HeadingSectionTitleContent-TeamImage"
    >
      <Trans>
        Notre équipe
      </Trans>
    </TopModel>
    <TeamMembers />
  </ouiDom.HeadingSection.HeadingSection>
);
